var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZoomInBlack24Dp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "zoom_in_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.47,
    height: 41.47,
    viewBox: "0 0 41.47 41.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M0,0H41.47V41.47H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M24.6,22.008H23.233l-.484-.467a11.263,11.263,0,1,0-1.21,1.21l.467.484V24.6l7.361,7.344a1.8,1.8,0,0,0,2.557,0l.017-.017a1.8,1.8,0,0,0,0-2.557Zm-10.368,0a7.776,7.776,0,1,1,7.776-7.776A7.765,7.765,0,0,1,14.231,22.008Zm0-12.1a.856.856,0,0,0-.864.864v2.592H10.775a.864.864,0,0,0,0,1.728h2.592v2.592a.864.864,0,0,0,1.728,0V15.1h2.592a.864.864,0,0,0,0-1.728H15.095V10.776A.856.856,0,0,0,14.231,9.912Z",
    transform: "translate(2.185 2.183)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomInBlack24Dp);
export default __webpack_public_path__ + "static/media/zoom_in_black_24dp.eb3586dc4bafaf3c4b5b920f11a613ad.svg";
export { ForwardRef as ReactComponent };